import * as React from 'react';

import { IConstructionProgressStage } from '../../../../types/constructionProgress';
import { Tabs } from '../../../Tabs';
import { prepareTabs } from './helpers';
import styles from './StagesTabs.css';

export interface IStagesTabsProps {
  onChange(index: number): void;
  stageIndex: number;
  stages: IConstructionProgressStage[];
}

export const StagesTabs: React.FC<IStagesTabsProps> = ({ onChange, stageIndex, stages }) => {
  const tabs = React.useMemo(() => prepareTabs(stages), [stages]);

  const handleChange = React.useCallback(
    (value: string) => {
      onChange(+value);
    },
    [onChange],
  );

  return (
    <div className={styles['tabs']}>
      <Tabs tabs={tabs} activeTab={String(stageIndex)} onChange={handleChange} theme="dark" />
    </div>
  );
};
